import { useDeleteAssessor } from "@/api/console/assessor/useDeleteAssessor";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import toast from "@/lib/toast";
import useAssessorDialog from "@/src/console/(auth)/assessors/_hooks/useAssessorDialog";
import { SpinnerIosRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

function DeleteAssessorDialog() {
  const { t } = useTranslation();
  const { type, assessor, resetDialog } = useAssessorDialog();

  const assessorId = assessor?.id ?? -1;
  const assessorName = assessor?.name ?? "";

  const { trigger, isMutating } = useDeleteAssessor(assessorId, {
    onSuccess: (data) => {
      toast.success(data.message);
      mutate("/console/admin_users");
      resetDialog();
    },
  });

  return (
    <Dialog
      open={type === "delete"}
      onOpenChange={(open) => !open && resetDialog()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("delete-assessor")}</DialogTitle>
        </DialogHeader>
        <div className=" flex flex-col p-6">
          {`Are you sure you want to delete ${assessorName}?`}
          <div className=" flex flex-row mt-8 ml-auto space-x-4">
            <Button onClick={() => resetDialog()} variant="ghost">
              {t("cancel")}
            </Button>
            <Button
              isLoading={isMutating}
              LoadingComponent={<SpinnerIosRegular className="animate-spin" />}
              variant="destructive"
              onClick={() => trigger()}
            >
              {t("confirm")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteAssessorDialog;
